import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { ShoppingBag } from "lucide-react";
import { useContext } from "react";
import { formatterChartData } from "../../../shared/utils";
import { DashboardContext } from "../context/DashboardContext";


const COLORS = ["#F59E0B", "#FBBF24", "#FCD34D", "#FDE68A", "#F97316"];


export default function GraphicOrderbump() {

    const { data } = useContext(DashboardContext);
    const chartData = formatterChartData(data.pizza_orderbumps);
    const total = chartData.reduce((acc, item) => acc + (item.quantidade || 0), 0);


    return (
        <div className="surface-card surface-card-hover p-6">
            <div className="flex items-center justify-between mb-5">
                <div className="flex items-center gap-2">
                    <span className="h-8 w-8 rounded-lg bg-warning-500/15 ring-1 ring-warning-500/25 grid place-items-center">
                        <ShoppingBag className="h-4 w-4 text-warning-400" />
                    </span>
                    <div>
                        <h3 className="heading-3">Orderbumps</h3>
                        <p className="text-xs text-ink-4">Distribuição dos orderbumps</p>
                    </div>
                </div>
                <span className="chip-warning tabular-nums">{total} vendas</span>
            </div>

            <ResponsiveContainer width="100%" height={280}>
                <PieChart>
                    <Pie
                        data={chartData}
                        dataKey="quantidade"
                        nameKey="produto"
                        cx="50%"
                        cy="50%"
                        innerRadius={60}
                        outerRadius={100}
                        paddingAngle={2}
                        stroke="#0F0F11"
                        strokeWidth={3}
                        label={({ percent }) => percent > 0.05 ? `${(percent * 100).toFixed(0)}%` : ""}
                        labelLine={false}
                    >
                        {chartData.map((_, index) => (
                            <Cell key={`cell-ob-${index}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                    </Pie>
                    <Tooltip
                        contentStyle={{
                            background: '#15151A',
                            border: '1px solid rgba(255,255,255,0.08)',
                            borderRadius: '12px',
                            boxShadow: '0 8px 24px -12px rgba(0,0,0,0.6)',
                            color: '#FAFAFA',
                            fontSize: '13px',
                        }}
                        formatter={(value, _name, props) => [`${value} vendas`, props.payload.produto]}
                    />
                    <Legend
                        verticalAlign="bottom"
                        iconType="circle"
                        wrapperStyle={{ fontSize: '12px', color: '#A1A1AA', paddingTop: '12px' }}
                    />
                </PieChart>
            </ResponsiveContainer>
        </div>
    );
}
